import { useTranslation } from 'react-i18next'
import { H3, Text } from '@/components/atoms'
import { FileUpload } from '@/components/molecules'
import { useRentersFormTwo } from './page.onboarding-renters-form-two.hook'

interface RentersFormTwoPageProps {
  onContinue: () => void
  onSkip: () => void
  onRegisterSubmit?: (fn: () => Promise<void>) => void
  onLoadingChange?: (loading: boolean) => void
  planName?: string
}

export function RentersFormTwoPage({
  onContinue,
  onRegisterSubmit,
  onLoadingChange,
  planName = 'Home',
}: RentersFormTwoPageProps) {
  const { t } = useTranslation()
  const { displayFileName, previewUrl, handleFileSelect, uploadError } =
    useRentersFormTwo({
      onContinue,
      onRegisterSubmit,
      onLoadingChange,
    })

  return (
    <div className="flex flex-col gap-6">
      <H3 className="text-neutral-900">
        {t('onboarding.renters.form.propertyTour.title')}
      </H3>

      <FileUpload
        label={t('onboarding.renters.form.propertyTour.uploadLabel', {
          home: planName,
        })}
        variant="video"
        previewUrl={previewUrl}
        selectedFileName={displayFileName}
        onFileSelect={handleFileSelect}
      />

      {uploadError && (
        <Text className="text-error-base">
          {t('onboarding.renters.form.propertyTour.uploadError')}
        </Text>
      )}
    </div>
  )
}
